const SelectedMarker = () => {
  return (
    <svg
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.75 16C31.75 20.3407 29.7867 24.2872 26.8019 28.1624C24.2953 31.4169 21.0873 34.5979 17.7517 37.9055C17.1707 38.4817 16.5858 39.0617 16 39.6466C15.4142 39.0617 14.8293 38.4817 14.2483 37.9055C10.9127 34.5979 7.70474 31.4169 5.19806 28.1624C2.2133 24.2872 0.25 20.3407 0.25 16C0.25 7.29807 7.29807 0.25 16 0.25C24.7019 0.25 31.75 7.29807 31.75 16Z"
        fill="#FF5E00"
        stroke="#FF5E00"
        strokeWidth="0.5"
      />
      <circle cx="16" cy="16" r="6" fill="#E6EFF5" />
    </svg>
  );
};

export default SelectedMarker;
